"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderByDescFilter = exports.TextFilter2 = exports.TextFilter = exports.DateFilter = exports.ScopeFilter = exports.NumberFilter = exports.SelectFilter = exports.getPaginationParams = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const helpers_1 = require("../../commonFiles/helpers");
function getPaginationParams(pagination) {
    let params = {};
    if (pagination === null || pagination === void 0 ? void 0 : pagination.first_page_url) {
        let url = pagination.first_page_url;
        params = Object.fromEntries(new URLSearchParams(url.substring(url.indexOf('?'))));
    }
    return params;
}
exports.getPaginationParams = getPaginationParams;
function SelectFilter(props) {
    const options = props.options;
    const [selectedOption, setSelectedOption] = react_1.default.useState();
    const apiCall = props.apiCall;
    const [data, setdata] = props.useState;
    const property = props.property;
    const label = props.label;
    const defaultValue = props.defaultValue;
    const valueKeyWord = props.valueKeyWord;
    const nameKeyWord = props.nameKeyWord;
    function fetchData(params = null) {
        // console.log('Paginator fetchData', link)
        (0, helpers_1.ApiCallHandler)(() => apiCall(params), (data) => { setdata(data); }, 'SelectFilter fetchData', true);
    }
    return react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'd-flex' },
            react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (e) => { setSelectedOption(e.target.value); }, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : 'undefined', className: 'mx-1' },
                react_1.default.createElement("option", { value: 'undefined' }, label !== null && label !== void 0 ? label : property), options === null || options === void 0 ? void 0 :
                options.map((option, index) => (react_1.default.createElement("option", { key: index, value: option[valueKeyWord !== null && valueKeyWord !== void 0 ? valueKeyWord : 'value'] }, option[nameKeyWord !== null && nameKeyWord !== void 0 ? nameKeyWord : 'name'])))),
            react_1.default.createElement("button", { className: 'btn btn-primary text-white', onClick: () => {
                    let params = Object.assign({}, selectedOption === 'undefined' ? { [property]: undefined } : { [property]: selectedOption });
                    fetchData(params);
                } }, "\u0628\u062D\u062B")));
}
exports.SelectFilter = SelectFilter;
function NumberFilter(props) {
    const params = props.params;
    const fetchPage = props.fetchPage;
    const property = props.property;
    const label = props.label;
    const [number, setnumber] = react_1.default.useState(null);
    return (react_1.default.createElement("div", { className: "col-5 border rounded p-1 mx-2" },
        react_1.default.createElement("div", { className: "d-flex flex-row my-2 align-items-center" },
            react_1.default.createElement("label", null, label !== null && label !== void 0 ? label : property),
            react_1.default.createElement("br", null),
            react_1.default.createElement("input", { className: "form-control ml-1", type: "number", onChange: (e) => setnumber(e.target.value) }),
            react_1.default.createElement("br", null),
            react_1.default.createElement("button", { className: "col-2 form-control btn btn-success ml-1", onClick: () => {
                    let newparams = Object.assign({}, number === null ? null : { [property]: number });
                    fetchPage(Object.assign(Object.assign({}, params), newparams));
                } }, "\u0641\u0644\u062A\u0631\u0629"))));
}
exports.NumberFilter = NumberFilter;
function ScopeFilter(props) {
    // const params = props.params
    const fetchPage = props.fetchPage;
    const property = props.property;
    const label = props.label;
    let linkParams = Object.fromEntries(new URLSearchParams(location.search));
    return (react_1.default.createElement("div", { className: "col-5 border rounded p-1 mx-2" },
        react_1.default.createElement("div", { className: "d-flex flex-row my-2 align-items-center" },
            react_1.default.createElement("button", { type: "button", className: ((linkParams === null || linkParams === void 0 ? void 0 : linkParams[property]) == 'true') ? "btn btn-success mx-2 my-1" : "btn btn-info mx-2 my-1", onClick: () => fetchPage(linkParams[property] == 'true' ? Object.assign(Object.assign({}, linkParams), { [property]: undefined }) : Object.assign(Object.assign({}, linkParams), { [property]: 'true' })) }, label !== null && label !== void 0 ? label : property))));
}
exports.ScopeFilter = ScopeFilter;
function DateFilter(props) {
    const params = props.params;
    const fetchPage = props.fetchPage;
    const property = props.property;
    const label = props.label;
    const [date, setdate] = react_1.default.useState(null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "col-5 border rounded p-1 m-2" },
            react_1.default.createElement("div", { className: "d-flex flex-row my-2 align-items-center" },
                react_1.default.createElement("label", null, label !== null && label !== void 0 ? label : property),
                react_1.default.createElement("br", null),
                react_1.default.createElement("input", { className: "form-control ml-1", type: "date", onChange: (e) => setdate(e.target.value) }),
                react_1.default.createElement("br", null),
                react_1.default.createElement("button", { className: "col-2 form-control btn btn-success ml-1", onClick: () => {
                        let newparams = Object.assign({}, date === null ? null : { [property]: date });
                        fetchPage(Object.assign(Object.assign({}, params), newparams));
                    } }, "\u0641\u0644\u062A\u0631\u0629")))));
}
exports.DateFilter = DateFilter;
function TextFilter(props) {
    var _a;
    const property = props.property;
    const label = props.label;
    const apiCall = props.apiCall;
    const [data, setdata] = props.useState;
    const [text, settext] = react_1.default.useState((_a = props.initValue) !== null && _a !== void 0 ? _a : null);
    function fetchData(params = null) {
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield apiCall(params); }), (data) => {
            setdata(data);
        }, "TextFilter fetchData", true);
    }
    function isFilterActive() {
        const params = getPaginationParams(data);
        if (params[property])
            return true;
        else
            return false;
    }
    return (react_1.default.createElement("div", { className: "my-1" },
        react_1.default.createElement("div", { className: "" }, label !== null && label !== void 0 ? label : property),
        react_1.default.createElement("div", { className: "d-flex justify-content-around" },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: label !== null && label !== void 0 ? label : property, className: "mx-1", type: "text", value: text !== null && text !== void 0 ? text : "", onChange: (e) => settext(e.target.value) }),
            isFilterActive() ? (react_1.default.createElement("button", { className: "mx-1 btn btn-danger", onClick: () => {
                    settext(null);
                    let newparams = Object.assign({}, { [property]: undefined });
                    fetchData(Object.assign({}, newparams));
                } }, "X")) : null,
            react_1.default.createElement("button", { className: "btn btn-primary mx-1", onClick: () => {
                    let newparams = Object.assign({}, text === null ? null : { [property]: text });
                    fetchData(Object.assign({}, newparams));
                } }, "بحث"))));
}
exports.TextFilter = TextFilter;
function TextFilter2(props) {
    const property = props.property;
    const label = props.label;
    const apiCall = props.apiCall;
    const className = props.className;
    const [data, setdata] = props.useState;
    const [text, settext] = react_1.default.useState(null);
    function fetchData(params = null) {
        // console.log('Paginator fetchData', link)
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield apiCall(params); }), (data) => { setdata(data); }, 'TextFilter fetchData', true);
    }
    function isFilterActive() {
        const params = getPaginationParams(data);
        if (params[property])
            return true;
        else
            return false;
    }
    return (react_1.default.createElement("div", { className: className !== null && className !== void 0 ? className : "my-1 bg-white" },
        react_1.default.createElement("div", { className: 'd-flex justify-content-around' },
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: label !== null && label !== void 0 ? label : property, className: 'mx-1 ', type: "text", value: text !== null && text !== void 0 ? text : '', onChange: (e) => settext(e.target.value) }),
            isFilterActive() ? react_1.default.createElement("button", { className: 'mx-1 btn btn-danger text-white', onClick: () => {
                    settext(null);
                    let newparams = Object.assign({}, { [property]: undefined });
                    fetchData(Object.assign({}, newparams));
                } }, "X") : null,
            react_1.default.createElement("button", { className: 'btn btn-primary mx-1 text-white', onClick: () => {
                    let newparams = Object.assign({}, text === null ? null : { [property]: text });
                    fetchData(Object.assign({}, newparams));
                } }, 'بحث'))));
}
exports.TextFilter2 = TextFilter2;
function OrderByDescFilter(props) {
    const params = props.params;
    const fetchPage = props.fetchPage;
    const property = props.property;
    const label = props.label;
    // const [trait, settrait] = React.useState(null)
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "col-5 border rounded p-1 m-2" },
            react_1.default.createElement("div", { className: "d-flex flex-row my-2 align-items-center" },
                react_1.default.createElement("button", { type: "button", className: ((params === null || params === void 0 ? void 0 : params.orderByDesc) == property) ? "btn btn-success mx-2 my-1" : "btn btn-info mx-2 my-1", onClick: () => fetchPage(params['orderByDesc'] == property ? Object.assign(Object.assign({}, params), { orderByDesc: undefined }) : Object.assign(Object.assign({}, params), { orderByDesc: property })) }, label !== null && label !== void 0 ? label : property)))));
}
exports.OrderByDescFilter = OrderByDescFilter;
